(($, Drupal) => {
  Drupal.behaviors.kafReadmore = {
    attach: function (context, settings) {
      
      var $author = $('#blog-author--view-mode-full__bio', context);
      $(once('author', $author)).each(function () { 
        ReadMore('blog-author--view-mode-full__bio', {
          charLength: 280,
        });
      });

    }
  }
})(jQuery, Drupal);
